/* eslint-disable no-underscore-dangle */
import { GLOBAL } from 'saddlebag-browser';

const persistSponsoredAgent = () => {
  const $window = GLOBAL.getWindow();
  const { searchControlsParams } = $window.__internal;

  // Ensure searchControlsParams.sponsoredAgent is set in query parameters
  // so that it can be persisted by Flights Search Controls GC navigation
  if (searchControlsParams?.sponsoredAgent) {
    const parsedUrl = new URL($window.location.href);
    if (
      parsedUrl.searchParams.get('sponsoredagent') !==
      searchControlsParams.sponsoredAgent
    ) {
      parsedUrl.searchParams.set(
        'sponsoredagent',
        searchControlsParams.sponsoredAgent,
      );
      $window.history.replaceState({}, '', parsedUrl.toString());
    }
  }
};

export default persistSponsoredAgent;
